import { FaFileExcel } from "react-icons/fa6"
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { Button } from "react-bootstrap";

export function ButtonExportarExcel({
    data, 
    fileName, 
    noHayDatosMessage="No hay datos para exportar",
    columnas
}) {

    const exportarExcel = () => {
        if (data.length>0) {
            let newData = data.map((d) => {
                let r = {};
                columnas.map((c) => {r[c.titulo] = d[c.atributo]});
                return r;
            })
            const worksheet = XLSX.utils.json_to_sheet(newData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
            saveAs(blob, `${fileName}.xlsx`);
        } else {
            alert(noHayDatosMessage);
        }
    };

    return <Button id="btnExportarExcel" onClick={exportarExcel}
        title="Exportar a Excel">
        Exportar <FaFileExcel></FaFileExcel>
    </Button>
}